import { ChangeEvent, useEffect, useState } from 'react'

import { Input, InputRadio } from '..'

import * as S from './styles'

type ScaleQuestionProps = {
  label: string
  labelJustification: string
  valueToJustification: string
  order: number
  optionChecked: number
  onChange: (e: ChangeEvent<HTMLInputElement>, valueRadio: number) => void
}

const ScaleQuestion = ({
  label,
  labelJustification,
  valueToJustification,
  order,
  optionChecked,
  onChange
}: ScaleQuestionProps) => {
  const [valuesToRadio, setValuesToRadio] = useState<number>()
  const [inputSave, setInputSave] = useState<any>()

  const options = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

  useEffect(() => {
    if (optionChecked) {
      setValuesToRadio(optionChecked)
    }
  }, [optionChecked])

  return (
    <S.Wrapper>
      <S.Title>{label}</S.Title>
      <S.ScaleContainer>
        {options.map((option) => (
          <InputRadio
            key={`${order}-${option}`}
            name={`radio-scale-question-${order}`}
            value={valuesToRadio}
            label={option}
            labelFor={`${order}-${option}`}
            defaultChecked={optionChecked === Number(option)}
            onCheck={() => {
              setValuesToRadio(Number(option))
              onChange(inputSave, Number(option))
            }}
            labelColor="#4f4f4f"
          />
        ))}
      </S.ScaleContainer>
      {(!!valuesToRadio || valuesToRadio === 0) && (
        <Input
          name="title"
          type="text"
          label={labelJustification}
          labelColor="#000"
          placeholder="Resposta:"
          hasQuestionInput
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setInputSave(e)
            onChange(e, valuesToRadio)
          }}
          defaultValue={valueToJustification}
        />
      )}
    </S.Wrapper>
  )
}

export default ScaleQuestion
